const KEY = 'tri.alerts.recentPlaceholders';
const MAX_RECENTS = 5;

/** The names a user inserted last, newest first; kept per browser, never fails (private mode, bad JSON). */
export const loadRecents = (): string[] => {
    try {
        const parsed = JSON.parse(window.localStorage.getItem(KEY) ?? '[]');

        return Array.isArray(parsed) ? parsed.filter((entry) => typeof entry === 'string').slice(0, MAX_RECENTS) : [];
    } catch {
        return [];
    }
};

/** The list after using `name`: first, without duplicates, at most five. Pure. */
export const withRecent = (recents: string[], name: string): string[] =>
    [name, ...recents.filter((entry) => entry !== name)].slice(0, MAX_RECENTS);

export const saveRecents = (recents: string[]): void => {
    try {
        window.localStorage.setItem(KEY, JSON.stringify(recents));
    } catch {
        // Storage unavailable: recents are a convenience only.
    }
};
